import { BlockId } from '@shared/block-ids';
import { seedRandom } from '../utils/math';

export interface TreeBlock {
  dx: number;
  dy: number;
  dz: number;
  id: BlockId;
}

export function generateOakTree(seed: number): TreeBlock[] {
  const rng = seedRandom(seed);
  const blocks: TreeBlock[] = [];
  const trunkHeight = 4 + Math.floor(rng() * 3);

  // Trunk
  for (let y = 0; y < trunkHeight; y++) {
    blocks.push({ dx: 0, dy: y, dz: 0, id: BlockId.WOOD_OAK });
  }

  // Leaves - wider at bottom, narrower at top
  const leafStart = trunkHeight - 2;
  for (let y = leafStart; y <= trunkHeight + 1; y++) {
    const radius = y <= trunkHeight - 1 ? 2 : 1;
    for (let x = -radius; x <= radius; x++) {
      for (let z = -radius; z <= radius; z++) {
        if (x === 0 && z === 0 && y < trunkHeight) continue;
        if (Math.abs(x) === radius && Math.abs(z) === radius && rng() > 0.6) continue;
        blocks.push({ dx: x, dy: y, dz: z, id: BlockId.LEAVES_OAK });
      }
    }
  }

  return blocks;
}

export function generateBirchTree(seed: number): TreeBlock[] {
  const rng = seedRandom(seed);
  const blocks: TreeBlock[] = [];
  const trunkHeight = 5 + Math.floor(rng() * 2);

  for (let y = 0; y < trunkHeight; y++) {
    blocks.push({ dx: 0, dy: y, dz: 0, id: BlockId.WOOD_BIRCH });
  }

  const leafStart = trunkHeight - 3;
  for (let y = leafStart; y <= trunkHeight; y++) {
    const radius = y <= trunkHeight - 2 ? 2 : 1;
    for (let x = -radius; x <= radius; x++) {
      for (let z = -radius; z <= radius; z++) {
        if (x === 0 && z === 0 && y < trunkHeight) continue;
        if (Math.abs(x) === radius && Math.abs(z) === radius && rng() > 0.5) continue;
        blocks.push({ dx: x, dy: y, dz: z, id: BlockId.LEAVES_BIRCH });
      }
    }
  }

  return blocks;
}

export function shouldPlaceTree(
  noise2dVal: number,
  heightAboveSea: number,
  biomeTreeDensity: number,
): boolean {
  return noise2dVal > (1 - biomeTreeDensity * 0.15) && heightAboveSea > 0 && heightAboveSea < 40;
}
